import React from 'react';
import { motion } from 'framer-motion';

export const CharlesIntro = () => {
  return (
    <section 
      data-testid="charles-intro"
      className="section-padding px-8 md:px-12 bg-gray-50"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="order-2 lg:order-1"
          >
            <div className="image-frame relative">
              {/* Orange corner accent */}
              <div className="absolute -top-3 -left-3 w-24 h-24 border-l-4 border-t-4 border-amber-600 z-10" />
              <img 
                src="https://customer-assets.emergentagent.com/job_0a5b184c-09eb-4e0a-aed9-2fa1b250a46a/artifacts/ijjdk2b8_cptv.png"
                alt="Charles Payne"
                className="w-full h-auto grayscale hover:grayscale-0 transition-all duration-700"
                data-testid="charles-image"
              />
              {/* Bottom orange bar */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-amber-600" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="order-1 lg:order-2"
          >
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-[2px] bg-amber-600" />
              <p className="font-sans text-xs tracking-widest uppercase text-gray-400">
                About Charles Payne
              </p>
            </div>
            
            <h2 className="font-editorial text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-8">
              He Saw How Wall Street Really Works.{' '}
              <span className="text-amber-600">Then He Built a Better Way In.</span>
            </h2>

            <div className="font-sans text-gray-600 leading-relaxed space-y-5">
              <p>
                Charles Payne is the host of <em className="text-gray-900 not-italic font-medium">Making Money with Charles Payne</em> on Fox Business. He is a bestselling author with over 40 years of personal investing experience across every market cycle from the 1987 crash to the pandemic volatility of 2020 and every major correction in between. He grew up in Harlem with no financial inheritance and no institutional advantage, worked his way into the financial industry, and came to understand something most financial professionals will not tell you plainly: the advice given to retail investors is shaped far more by what generates revenue than by what generates results.
              </p>

              <p className="font-semibold text-gray-900">
                He built Payne's Education specifically to change that. Not a newsletter. Not a picks service. An education program built on one premise: everyday investors deserve to learn the same structured, disciplined framework that professional investors use.
              </p>
            </div>

            {/* Credentials with accent dots */}
            <div className="mt-10 pt-8 border-t border-gray-200">
              <div className="flex flex-wrap gap-x-8 gap-y-3">
                {['Fox Business Host', 'Bestselling Author', '40+ Years Experience'].map((item, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-amber-600 rounded-full" />
                    <span className="text-sm text-gray-600">{item}</span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
